(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  function boot(e){
    const roots = (e?.target?.matches?.('.shopify-section'))
      ? e.target.querySelectorAll('.camp-slider')
      : document.querySelectorAll('.camp-slider');
    if(!roots.length) return;

    ensureJq().then(ensureSlick).then(() => {
      roots.forEach(root => initOne(root));
    }).catch(err => console.error('[camp-slick] init error', err));
  }

  function ensureJq(){
    if (window.jQuery) return Promise.resolve();
    return loadScript('https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js');
  }
  function ensureSlick(){
    if (window.jQuery && jQuery.fn && jQuery.fn.slick) return Promise.resolve();
    return Promise.all([
      loadStyle('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css'),
      loadStyle('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css'),
      loadScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js')
    ]);
  }

  function initOne(root){
    const $ = window.jQuery;
    const $slick = $(root).find('.camp-slick');
    if(!$slick.length) return;
    if($slick.hasClass('slick-initialized')) $slick.slick('unslick');

    const autoplay = (root.dataset.autoplay === 'true' || root.dataset.autoplay === '1');
    const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;

    const gap  = toInt(getVar(root, '--gap'), 24);
    const peek = getPeek(root);

    $(root).find('.camp-slide').css({ marginLeft: gap/2, marginRight: gap/2 });

    $slick.slick({
      infinite: true,
      speed: 500,
      cssEase: 'ease',
      arrows: true,
      prevArrow: $(root).find('.camp-prev'),
      nextArrow: $(root).find('.camp-next'),
      dots: false,
      centerMode: true,
      slidesToShow: 2,
      centerPadding: peek + 'px',
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, centerPadding: peek + 'px' } },
        { breakpoint: 768,  settings: { slidesToShow: 1, centerPadding: peek + 'px' } }
      ]
    });

    const reposition = () => { try { $slick.slick('setPosition'); } catch(_){} };
    window.addEventListener('load', reposition, { once:true });
    window.addEventListener('resize', () => {
      const p = getPeek(root) + 'px';
      try { $slick.slick('slickSetOption', 'centerPadding', p, true); } catch(_) {}
      reposition();
    }, { passive: true });
  }

  function getPeek(root){
    const isLg = window.matchMedia('(min-width: 1024px)').matches;
    const v = getVar(root, isLg ? '--peek-lg' : '--peek-sm');
    return toInt(v, isLg ? 48 : 16);
  }
  function getVar(root, name){ return getComputedStyle(root).getPropertyValue(name) || ''; }
  function toInt(v, def){ const n = parseInt(String(v).trim(), 10); return Number.isFinite(n) ? n : def; }

  function loadScript(src){
    return new Promise((res, rej) => {
      if ([...document.scripts].some(s => s.src === src)) return res();
      const s=document.createElement('script'); s.src=src; s.onload=res; s.onerror=rej; document.head.appendChild(s);
    });
  }
  function loadStyle(href){
    return new Promise((res, rej) => {
      if ([...document.styleSheets].some(s => s.href===href)) return res();
      const l=document.createElement('link'); l.rel='stylesheet'; l.href=href; l.onload=res; l.onerror=rej; document.head.appendChild(l);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
(function(){
  const ROOT_ID = 'ftc-{{ section.id }}';

  function init(root){
    if(!root) return;

    const openBtn = root.querySelector('[data-nl-open]');
    const modal   = root.querySelector('#ftc-nl-modal-{{ section.id }}');
    if(!openBtn || !modal) return;

    const dialog  = modal.querySelector('.ftc-modal__dialog');
    const focusablesSel = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function open(){
      modal.hidden = false;
      if(!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex','-1');
      const first = modal.querySelector(focusablesSel);
      (first || dialog).focus();
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      modal.addEventListener('click', backdropClose);
    }

    function close(){
      modal.hidden = true;
      if(openBtn) openBtn.focus();
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      modal.removeEventListener('click', backdropClose);
    }

    function onKeydown(e){
      if(e.key === 'Escape'){ e.preventDefault(); close(); return; }
      if(e.key === 'Tab'){
        const f = [...modal.querySelectorAll(focusablesSel)].filter(el => el.offsetParent !== null);
        if(!f.length) return;
        const first=f[0], last=f[f.length-1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    }

    function backdropClose(e){
      if(e.target.matches('[data-close]')) close();
    }

    openBtn.addEventListener('click', open);

    // 送信後メッセージがサーバ描画されていれば、自動オープン（成功/エラー表示用）
    if(modal.querySelector('.ftc-modal__msg')) open();
  }

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once:true });
    else fn();
  }

  // 初回
  ready(() => init(document.getElementById(ROOT_ID)));

  // テーマエディタでセクションの再読み込みに対応
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target && e.target.querySelector && e.target.querySelector('#' + ROOT_ID);
    if(root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
